<!-- 工具条组件 -->
<template>
    <div class="preorder" v-show="showPre">
        <div class="buy-car-ctn"
             @mouseenter="mouseenterHandle"
             @mouseleave="mouseleaveHandle"
        >
            <div class="dotted"></div>
            <div class="buy-car">
                <i class="fa fa-shopping-cart"></i>
                <div>待售商品清单</div>
            </div>
            <div class="goods-num">{{checkedNum}}</div>
            <preOrderGoods :showState="showContent" ref="preOrderGoods" @getNum="getNum"></preOrderGoods>
        </div>
    </div>
</template>
<script>
import preOrderGoods from './preOrderGoods.vue';
export default {
    name: '',
    components: {
        preOrderGoods
    },
    props: [],
    data() {
        return {
            showContent: false,
            checkedNum: 0,
            showPre: false
        };
    },
    mounted() {},
    watch: {},
    methods: {
        getNum(num) {
            this.checkedNum = num;
        },
        getTableData() {
            this.$refs.preOrderGoods.getTableData();
        },
        mouseenterHandle() {
            if (this.showContent === false) {
                this.showContent = true;
                this.getTableData();
            }
        },
        mouseleaveHandle() {
            this.showContent === true && (this.showContent = false);
        },
        showPreOrder() {
            this.showPre = true;
            let data = this.$util.getLocalStorage('preOrderGoodsList');
            if (data && data.length > 0) this.checkedNum = data.length;
        },
        closePreOrder() {
            this.showPre = false;
        }
    }
};
</script>
<style lang="less" scoped>
.suit-count-money {
    padding-right: 30px;
    text-align: right;
    span {
        margin-left: 20px;
    }
}
.suit-item {
    border: 1px solid @border1Color;
    padding: 5px;
}
.promotion-item {
    display: flex;
    margin-right: 20px;
    padding-bottom: 10px;
}
.promotion-type {
    background: red;
    color: white;
    width: 50px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    margin-right: 150px;
}
.del-btn {
    cursor: pointer;
    color: @theme;
}
.goods-list {
    max-height: 375px;
    overflow-y: auto;
}
.car-msg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    line-height: 40px;
}
.goods-price {
    display: inline-block;
    font-weight: bold;
    margin-bottom: 5px;
}
.goods-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    padding-bottom: 5px;
    border-bottom: 1px dashed @border3Color;
    img {
        border: 1px solid @border3Color;
        margin-right: 10px;
        width: 50px;
        height: 50px;
    }
}
.goods-name {
    width: 150px;
    -webkit-line-clamp: 3;
}
.buy-car-title {
    font-size: @font-xs;
    font-weight: bold;
    padding-bottom: 10px;
}
.buy-car-content {
    position: absolute;
    left: 0;
    top: 100px;
    transform: translate(-100%, 0);
    width: 350px;
    height: 450px;
    background: white;
    border: 1px solid @border3Color;
    padding: 10px;
    text-align: left;
}
.preorder {
    position: absolute;
    top: 25%;
    right: 0;
    width: 36px;
    height: 200px;
    background: #eee;
    text-align: center;
    z-index: 99;
    border-radius: 6px 0 0 6px;
}
.dotted {
    height: 10px;
}
.buy-car-ctn {
    cursor: pointer;
    &:hover {
        background: white;
    }
}
.buy-car {
    width: 16px;
    margin: 0 auto;
    i {
        font-size: 18px;
    }
}
.goods-num {
    color: white;
    width: 24px;
    height: 24px;
    line-height: 24px;
    background: @theme;
    border-radius: 50%;
    margin: 10px auto;
}
.back-top {
    cursor: pointer;
    position: absolute;
    bottom: 150px;
    left: 5px;
    font-size: 30px;
}
</style>
